import React from "react";
import { useMediaQuery } from "react-responsive";
import { useSelector } from "react-redux";
import { UNAVAILABLE_FEATURES } from "../../features/slices/UserSlice";
import FeatureUnavailableNotice from "../common/FeatureUnavailableNotice";

export default function PhoneAndEmail() {
  const user = useSelector((state) => state.user);
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const { phone, phoneVerified, email } = user.userData;
  const emailUpdateDisabled = UNAVAILABLE_FEATURES.updateEmail;
  return (
    <>
      <div className="row">
        <div className="col-xl-6 col-md-8 col-lg-8 col-12 pt-4">
          <h6>Mobile Verification</h6>
          <label className="text--normal text--light mb-2 mt-3">Phone</label>
          <div className="phoneEmail-verification-input mb-5">
            <input type="text" readOnly value={phone || ""} placeholder="Phone" />
            {phoneVerified ? (
              <div className="info--message verified-badge d-flex">
                <i className="bi bi-check2 mx-1"></i>
                <p className="mb-0">Verified</p>
              </div>
            ) : (
              <div className="info--message verified-badge not-verified d-flex">
                <i className="bi bi-exclamation-circle mx-1"></i>
                <p className="mb-0">Not verified</p>
              </div>
            )}
          </div>
        </div>
      </div>
      <hr />
      <div className="row">
        <div className="col-xl-6 col-lg-8 col-md-8 col-12 pt-4">
          <h6>Email Verification</h6>
          <label className="text--normal text--light mb-2 mt-3">Email</label>
          <div className="phoneEmail-verification-input mb-3">
            <input
              type="text"
              readOnly
              value={email || ""}
              placeholder="Email"
            />
            {!isMobile && <button disabled={emailUpdateDisabled}>Update</button>}
          </div>
          {isMobile && (
            <button
              className="standard-btn w-100 mb-3"
              disabled={emailUpdateDisabled}
            >
              Update
            </button>
          )}
          {emailUpdateDisabled && (
            <FeatureUnavailableNotice message="Email updates are not available yet. Please check back later." />
          )}
        </div>
      </div>
    </>
  );
}
